import React from 'react';
import styled, { css } from 'styled-components';
import {
  brandColours,
  fontSize,
  minBreakpointQuery,
  standardTransition,
} from '../../styles';
import { Link } from './Link';
import { Svg } from './Svg';
import rightArrow from '../../images/arrow-right.inline.svg';

//moved up for hover
const StyledArrowIcon = styled(Svg)`
  transition: ${standardTransition('fill')};

  ${({ alt }) => {
    if (alt) {
      return css`
        fill: ${brandColours.quaternary};
      `;
    }
  }}
`;

const StyledArrowLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 10px;
  transition: ${standardTransition('color')};

  ${minBreakpointQuery.large`
    ${fontSize(18)};
  `}

  &:hover {
    color: ${brandColours.tertiary};

    ${StyledArrowIcon} {
      fill: ${brandColours.tertiary};
    }
  }

  ${({ alt }) => {
    if (alt) {
      return css`
        color: ${brandColours.quaternary};
      `;
    }
  }}
`;

export const ArrowLink = ({ to, children, alt, ...props }) => (
  <StyledArrowLink to={to} alt={alt} {...props}>
    {children}
    <StyledArrowIcon image={rightArrow} alt={alt} />
  </StyledArrowLink>
);
